import englishMessages from "@/localization/locales/en.json";
import lithuanianMessages from "@/localization/locales/lt.json";
import { useLanguageStore } from "@/localization/store/use-language-store";

export type TranslationKey = keyof typeof englishMessages;
export type TranslationVariables = Record<string, string | number>;

export type AppLanguage = "en" | "lt";

/**
 * English is the default catalog and the one the key type is derived from, so a
 * key Lithuanian is missing is a compile error rather than a blank on screen.
 */
const MESSAGES = {
  en: englishMessages,
  lt: lithuanianMessages satisfies Record<TranslationKey, string>,
};

/**
 * Values are interpolated rather than concatenated, because a sentence built
 * from fragments cannot be reordered by a translator — and word order is one of
 * the things translation changes.
 */
export const translate = (
  language: AppLanguage,
  key: TranslationKey,
  variables: TranslationVariables = {},
) => {
  const message: string = MESSAGES[language][key] ?? englishMessages[key];
  return Object.entries(variables).reduce(
    (result, [name, value]) => result.replaceAll(`{${name}}`, String(value)),
    message,
  );
};

export const useTranslation = () => {
  const language = useLanguageStore((state) => state.language);
  return {
    language,
    t: (key: TranslationKey, variables?: TranslationVariables) =>
      translate(language, key, variables),
  };
};
